import { API_URL } from "./constant";

export async function getInitData(){
    try{
        const response = await fetch(`${API_URL}/initialdata/`,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })

        if(!response.ok){
            throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();
        return data;
    }catch(error){
        console.log("Error on api for getting init data",error)
        throw error;
    }
}

export async function loginUser(data) {
    try{
        const response = await fetch(`${API_URL}/login/`,{
            method:"POST",
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify(data)
        })
        
        const responseData = await response.json();
        
        if(!response.ok){
           const err = new Error("Login failed");
            err.status = response.status;
            err.data = responseData;
            throw err;
        }

        return responseData;

    }catch(error){
        console.log("Error on login api",error)
        throw error;
    }
}

export async function mfaVerification(data) {
    try{
        const response = await fetch(`${API_URL}/mfa/verify/`,{
            method:"POST",
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify(data)
        })
        
        const responseData = await response.json();
        
        if(!response.ok){
           const err = new Error("Verification Failed");
            err.status = response.status;
            err.data = responseData;
            throw err;
        }

        return responseData;

    }catch(error){
        console.log("Error while Verifying Otp",error)
        throw error;
    }
}

export async function resendOTP(data) {
    try{
        const response = await fetch(`${API_URL}/mfa/resend/`,{
            method:"POST",
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify(data)
        })
        
        const responseData = await response.json();
        
        if(!response.ok){
           const err = new Error("OTP resending Failed");
            err.status = response.status;
            err.data = responseData;
            throw err;
        }

        return responseData;

    }catch(error){
        console.log("Error while Resending Otp",error)
        throw error;
    }
}

export async function registerUser(data) {
    try{
        const response = await fetch(`${API_URL}/signup/`,{
            method:"POST",
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify(data)
        })
        
        const responseData = await response.json();
        
        if(!response.ok){
           const err = new Error("User Registeration Failed");
            err.status = response.status;
            err.data = responseData;
            throw err;
        }

        return responseData;

    }catch(error){
        console.log("Error while Registering new user",error)
        throw error;
    }
}